export type fetchLicenseInformationResponse = {
	firstActivationDate: number;
	hostname: string;
	products: object;
};

export const ACTIVE = 'ACTIVE';
